module.exports = __WEBPACK_EXTERNAL_MODULE_2__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"handlebars/dist/handlebars.runtime","commonjs2":"handlebars/dist/handlebars.runtime","amd":"handlebars.runtime","root":"handlebars"}
// module id = 2
// module chunks = 0